module.exports = __webpack_public_path__ + "img/img10.1d13213a.png";